import { PagePlaceholder } from "../components/PagePlaceholder";

export function SubstitutionPage() {
	return (
		<PagePlaceholder
			title="Substitution"
			subtitle="What is replacing your products, and what are you replacing? Cohort-gated (k≥10)."
			endpoint="/v1/insights/manufacturer/substitution"
			callout={[
				"Substitution rows below k=10 firms are aggregated to category labels ('various pendants in your category').",
				"At early v0 scale (~50 agents, 3–5 design partners), expect this surface to be sparse for months.",
				"This is a known cold-start; it lights up as the cohort grows.",
			]}
			rails={[
				{ heading: "Net substitution score", body: "Net = wins - losses for the period." },
				{ heading: "Top 'replaced by'", body: "Where your product lost — category labels only below k=10." },
				{ heading: "Top 'replaced others'", body: "Where your product won." },
				{ heading: "Top contexts", body: "By metro, project type." },
			]}
		/>
	);
}
